import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { useShortIdContext } from '@air/provider-short-id';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePublicStatesList } from '~/swr-hooks/filters/usePublicStatesList';

type PublicStatesSelectProps = {
  boardId: string | undefined;
} & BaseStringSelectProps;

export const PublicStatesSelect = memo(({ boardId, ...props }: PublicStatesSelectProps) => {
  const { shortId } = useShortIdContext();
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePublicStatesList({
    search: debouncedSearchValue,
    shortId,
    boardId,
  });

  return (
    <StringSelect
      placeholder="Search for state/province"
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PublicStatesSelect.displayName = 'PublicStatesSelect';
